<template>
    <div
        class="mt-4 flex-2 lg:text-2xl md:text-2xl sm:text-xl"
        v-html="`<p>${$t('patients.treatment.title')}</p>`"
    ></div>
    <div class="grid lg:grid-cols-2 md:grid-cols-2 grid-cols-1 gap-4 p-4">
        <GroupCard
            v-for="(category, index) in treatmentCategories"
            :key="index"
            :name="$t(category.title)"
            :items="category.items"
            :bgColor="itemBackgroundColor"
            :titleColor="itemTitleColor"
            :textColor="'text-white'"
            :link="category.link.value"
            :price="category.price"
        />
    </div>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
import GroupCard from "~/components/GroupCard.vue";

const { t } = useI18n();

import { useLanguagesStore } from "~/stores/languages";
const languageStore = useLanguagesStore();

// Make href reactive
const href = computed(
    () =>
        (languageStore.getSelectedLanguage === "no"
            ? "https://booking.pridok.no/appointment/e6af7ac5-8fcb-48d7-9f39-fb1ee283a522/KAR/df5ef6a7-f1f4-4003-9433-a92233d6c067"
            : "/contact") as string,
);

// Treatment categories and items
const treatmentCategories = [
    {
        title: "patients.treatment.list.subtitles.cardiology",
        items: [
            "patients.treatment.list.items.hypertension",
            "patients.treatment.list.items.arrhythmias",
            "patients.treatment.list.items.heartFailure",
            "patients.treatment.list.items.hypercholesterolemia",
            "patients.treatment.list.items.rehabilitationAfterHearthAttack",
            "patients.treatment.list.items.postCovid",
            "patients.treatment.list.items.weightLoss",
        ],
        link: href,
        price: 1999,
    },
    {
        title: "patients.treatment.list.subtitles.gastroenterology",
        items: [
            "patients.treatment.list.items.acidReflux",
            "patients.treatment.list.items.helicobacterPylori",
            "patients.treatment.list.items.ulcers",
            "patients.treatment.list.items.commonDigestiveDisorders",
            "patients.treatment.list.items.ibs",
            "patients.treatment.list.items.weightLoss",
        ],
        link: href,
        price: 1999,
    },
    {
        title: "patients.treatment.list.subtitles.endocrinology",
        items: [
            "patients.treatment.list.items.diabetes",
            "patients.treatment.list.items.hyperthyroidism",
            "patients.treatment.list.items.hypothyroidism",
            "patients.treatment.list.items.weightLoss",
        ],
        link: href,
        price: 1999,
    },
    {
        title: "patients.treatment.list.subtitles.urology",
        items: [
            "patients.treatment.list.items.phimosis",
            "patients.treatment.list.items.hydrocele",
            "patients.treatment.list.items.spermatocele",
            "patients.treatment.list.items.varicocele",
            "patients.treatment.list.items.urinationProblems",
            "patients.treatment.list.items.interstitialCystitis",
            "patients.treatment.list.items.urinaryTractInfection",
            "patients.treatment.list.items.informationAboutUrologicalProcedures",
            "patients.treatment.list.items.urologicalInfections",
        ],
        link: href,
        price: 1999,
    },
];

// Define item background color
const itemBackgroundColor = "bg-violet-900";
const itemTitleColor = "text-white";
</script>

<style scoped>
/* Additional custom styles if needed */
</style>
